export enum ReportFilterOperator {
    EQ = 'EQ',
    EQUALS = 'EQUALS',

    NEQ = 'NEQ',
    NOT_EQUALS = 'NOT_EQUALS',

    LIKE = 'LIKE',
    NOT_LIKE = 'NOT_LIKE',

    BETWEEN = 'BETWEEN',
    NOT_BETWEEN = 'NOT_BETWEEN',

    GT = 'GT',
    GTE = 'GTE',

    LT = 'LT',
    LTE = 'LTE',

    IS_NULL = 'IS_NULL',
    IS_NOT_NULL = 'IS_NOT_NULL',

    IN = 'IN',
    NOT_IN = 'NOT_IN',

    ANY = 'ANY',
    NOT_ANY = 'NOT_ANY',
}

export const VALUELESS_OPERATORS = [ReportFilterOperator.IS_NULL, ReportFilterOperator.IS_NOT_NULL]
